import React, {Fragment, forwardRef} from "react";
import {Loader} from "components";
import colors from "styles/themes.module.scss";
import styles from "mapx-components/Inputs/AutoComplete/SuggestionsListComponent/styles.module.scss";
import type {SuggestionsListComponentProps} from "mapx-components/Inputs/AutoComplete/SuggestionsListComponent/types";

// eslint-disable-next-line react/display-name
export const SuggestionsListComponent = forwardRef(
	<T extends {name: string}>(
		{
			suggestions,
			onClick,
			displayLoader,
			SuggestionListItemComponent,
		}: SuggestionsListComponentProps<T>,
		ref: React.Ref<HTMLDivElement>,
	): React.ReactElement | null => {
		if (suggestions.length === 0) {
			return null;
		}

		return (
			<div className={styles.suggestionContainer}>
				<div className={styles.suggestionList}>
					{suggestions.map((suggestion, index) => (
						<Fragment key={index}>
							{SuggestionListItemComponent ? (
								<SuggestionListItemComponent
									suggestion={suggestion}
									index={index}
									onClick={onClick}
								/>
							) : (
								<p
									className={styles.suggestionItem}
									onClick={() => onClick(suggestion)}
								>
									{suggestion.name}
								</p>
							)}
						</Fragment>
					))}

					{!displayLoader && (
						// sentinel for infinite scrolling
						<div ref={ref} style={{width: "100%", height: 1}} />
					)}

					{displayLoader && (
						<div className={styles.loaderWrapper}>
							<Loader
								height={40}
								width={40}
								type="ThreeDots"
								color={colors.loaderDotColor}
							/>
						</div>
					)}
				</div>
			</div>
		);
	},
) as <T>(
	props: SuggestionsListComponentProps<T> & {ref?: React.Ref<HTMLDivElement>},
) => React.ReactElement | null;

// SuggestionsListComponent.displayName = "SuggestionsListComponent";
